//type
import { offerType } from "../../api/offers/type/OfferType"

//component
import TimeAndHourBooking from "../TimeAndHourBooking"

//mui icon
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MergeTypeIcon from '@mui/icons-material/MergeType';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';


//utilis
import { formatDateTimeUTC } from "../../utils/formatDateTime"

//translate
import { useTranslation } from "react-i18next";
import i18n from "../../translate/i18n";
import { MyCarType } from "../../api/Host/type/AddCarType";


interface offerCardProps {
    element: offerType
    selectedCar?: MyCarType
    setAddAndUpdateOffer:(addAndUpdateOffer: string)=>void
    setSelectedOffer:(selectedOffer: offerType | null)=>void
    setOpenDeleteConfirmation: (openDeleteConfirmation: boolean) => void

}

const OfferCard = ({element, selectedCar ,setAddAndUpdateOffer, setSelectedOffer, setOpenDeleteConfirmation}: offerCardProps) => {
    const {t} = useTranslation()
    return (
        <>
        <div className="bg-[#c1c3c74a] shadow-xl rounded-lg p-3 flex flex-col gap-3 mb-5">
            <div className='flex justify-between gap-3'>
                <div>
                    <p>{t("price")}</p>
                    <p>{element.price}</p>
                </div>
                <div className="flex gap-2">
                    <div 
                    onClick={()=>{setAddAndUpdateOffer("edit"); setSelectedOffer(element)}}
                    className='cursor-pointer flex justify-center items-center w-[30px] h-[30px] bg-[#0073E6] text-white rounded-md'>
                        <EditIcon className='!text-[15px]'/>
                    </div>
                    <div
                    className='cursor-pointer flex justify-center items-center w-[30px] h-[30px] bg-red-500 text-white rounded-md'
                    onClick={() => {setOpenDeleteConfirmation(true); setSelectedOffer(element);}}>
                        <DeleteOutlineIcon/>
                    </div>
                </div>
            </div>
            <div className='flex justify-between gap-3'>
                <TimeAndHourBooking
                title={t("start_date")}
                value={`${formatDateTimeUTC(element.start_date || "").date}`}
                icon={<CalendarTodayIcon/>}
                type = {selectedCar?.fuel_type}
                /> 
                <div className="w-[40%]">
                    <TimeAndHourBooking
                    title={t("end_date")}
                    value={`${formatDateTimeUTC(element.end_date || "").date}`}
                    icon={<CalendarMonthIcon/>}
                    type = {selectedCar?.fuel_type}
                    /> 
                </div>
            </div>
            <div className='flex justify-between gap-3'>
                <TimeAndHourBooking
                title={t("start_time")}
                value={`${formatDateTimeUTC(element.start_date|| "").time}`}
                icon={<QueryBuilderIcon/>}
                type = {selectedCar?.fuel_type}
                /> 
                <div className="w-[40%]">
                    <TimeAndHourBooking
                    title={t("end_time")}
                    value={`${formatDateTimeUTC(element.end_date || "").time}`}
                    icon={<WatchLaterIcon/>}
                    type = {selectedCar?.fuel_type}
                    /> 
                </div> 
            </div>
            <div className='flex justify-between gap-1'>
                <TimeAndHourBooking
                title={t("period_unit")}
                value={t(element.period_unit)}
                icon={<MergeTypeIcon/>}
                type = {selectedCar?.fuel_type}
                />  
                <div className="w-[40%]">
                    <TimeAndHourBooking
                    title={t("period_count")}
                    value={element.period_count}
                    icon={<MergeTypeIcon/>}
                    type = {selectedCar?.fuel_type}
                    /> 
                </div>
            </div>
        </div>
        </>
    )
}

export default OfferCard